module.exports = __webpack_public_path__ + "static/media/circles.eb728687.png";